import { type PaletteOptions } from "@mui/material/styles";

import { muiThemePalette } from "./colors";

// ---------------------------------------------------------------------------
// Dark palette (admin preview). Only the outer chrome (navbar wrapper, which
// also provides the header strip background via `AppLayoutWrapperDesktop`)
// gets dark values. Inner content keeps the light palette so tab content,
// cards, and page chrome stay light — users found full inversion too jarring.
// ---------------------------------------------------------------------------

const DARK_NAVBAR_BACKGROUND = "#221416";
const DARK_NAVBAR_AVATAR_BACKGROUND = "#3A2628";
const DARK_NAVBAR_AVATAR_TEXT = "#BFB3A4";
const DARK_NAVBAR_ITEM_CONTENT = "#BFB3A4";
const DARK_NAVBAR_ITEM_CONTENT_SELECTED = "#FFFEFC";
const DARK_NAVBAR_ITEM_SELECTED_BACKGROUND = "#3A2628";
const DARK_NAVBAR_SECTION_TITLE = "#8A7A70";
const DARK_NAVBAR_SECTION_DIVIDER = "#3A2628";
const DARK_NAVBAR_USERNAME = "#FFFEFC";

export const muiThemePaletteDark: PaletteOptions = {
  ...muiThemePalette,
  navbar: {
    avatarBackground: DARK_NAVBAR_AVATAR_BACKGROUND,
    avatarText: DARK_NAVBAR_AVATAR_TEXT,
    background: DARK_NAVBAR_BACKGROUND,
    itemContent: DARK_NAVBAR_ITEM_CONTENT,
    itemContentSelected: DARK_NAVBAR_ITEM_CONTENT_SELECTED,
    itemSelectedBackground: DARK_NAVBAR_ITEM_SELECTED_BACKGROUND,
    sectionTitle: DARK_NAVBAR_SECTION_TITLE,
    sectionDivider: DARK_NAVBAR_SECTION_DIVIDER,
    userName: DARK_NAVBAR_USERNAME,
  },
};
